import { useQuery } from "react-query";
import { getHomeData } from "../../api/apiHome";

export const useHomeData = () => {
  return useQuery({ queryKey: "useHomeData", queryFn: getHomeData, retry: 2 });
};
